import { render } from "./OurSchool.vue?vue&type=template&id=dc828b2c"
import script from "./OurSchool.vue?vue&type=script&lang=js"
export * from "./OurSchool.vue?vue&type=script&lang=js"

import "./OurSchool.vue?vue&type=style&index=0&id=dc828b2c&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__